"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringEmptyToUndefined = stringEmptyToUndefined;
function stringEmptyToUndefined(value) {
  if (value === undefined || value === null) {
    return undefined;
  }
  if (value === '' || value.trim() === '') {
    return undefined;
  }
  return value;
}
//# sourceMappingURL=stringEmptyToUndefined.js.map